







import { Component, Vue } from "vue-property-decorator";
import Header from "../../components/Header.vue";
import LoginBox from "../../components/LoginBox.vue";
import { Auth } from "@/service/auth";
import requestService from "@/service/requestService";
import { Action, Getter } from "vuex-class";
import { PromiseService } from "@/service/PromiseService";
import { getFunctionSettingConfigKey, getFunctionSettingStateKey } from "@/store/modules/functionSetting";
@Component({
  components: {
    Header,
    LoginBox
  }
})
export default class UserLogin extends Vue {
  reqService: requestService;

  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [START] */
  @Getter("isCanQuickMitsumori", { namespace: "FunctionSetting"} )
  isCanQuickMitsumori: any;
  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [END] */

  // @Action("setState", { namespace: "FunctionSetting"} )
  // setStateFunctionSetting: any;

  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [START] */
  loading: boolean = false;
  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [END] */

  created() {
    // 前回のセッションが残っていた場合、削除する
    window.sessionStorage.removeItem(getFunctionSettingConfigKey());
    window.sessionStorage.removeItem(getFunctionSettingStateKey());
  }

  onSubmit() {
    this.reqService = new requestService();

    /** 2021-07-30 sh #6989 refactoring [START] */
    // const promise = this.getFunctionSettingPM();
    const promiseService = new PromiseService();
    const promise = promiseService.getFunctionSettingPM();
    /** 2021-07-30 sh #6989 refactoring [END] */

    Promise.all([promise]).then(() => {
      if (this.isCanQuickMitsumori) {
        this.$router.push("/user/userMenu");
      } else {
        // クイック見積を使えない場合、予約番号入力画面へ飛ぶ
        this.$router.push("/user/reservationnumber");
      }

    }, (err: any) => {
      // エラーだったらスキップして、予約番号入力画面へ飛ぶ
      this.$router.push("/user/reservationnumber");
    });
  }

  /** 2021-07-30 sh #6989 refactoring [START] */
  // getFunctionSettingPM() {
  //   let promise = new Promise((resolve, reject) => {
  //   this.reqService.getFunctionSettingPM().then(
  //       (response: any) => {
  //         if (response) {
  //            this.setStateFunctionSetting(response);
  //         }
  //         resolve();
  //       },
  //       (err: any) => { reject(); }
  //     )
  //   });
  // 
  //   return promise;
  // }
  /** 2021-07-30 sh #6989 refactoring [END] */

  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [START] */
  onLoading(e: any) {
    this.loading = e;
  }
  /** 2021-07-28 sh #6989 quick mitsumori for customer screen. (priority2) [END] */
}
